/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';

const MODULE_NAME = 'profile.machines.states.createPolicy';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const createPolicy = async (context: any, event: any) => {
  const currentState = 'CREATE_POLICY';
  const method = 'createPolicy';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const createPolicy = await srv?.agent?.getCreatePolicyProps(
        event?.payload
      );
      if (createPolicy?.policyNumber) {
        return resolve({
          key: 'CREATE_POLICY',
          value: {
            ...(createPolicy || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'CREATE_POLICY',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'CREATE_POLICY',
        value: err?.message,
      });
    }
  });
};
